var map = {
	"./battery_3blue.png": "0bcd",
	"./battery_3classic.png": "00d85",
	"./battery_3disable.png": "f869",
	"./battery_3green.png": "10a3",
	"./battery_3orange.png": "1501",
	"./battery_3purple.png": "10d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5078";